import { render, staticRenderFns } from "./SolicitudesRevisadasTabla.html?vue&type=template&id=d6479bdc&external"
import script from "./SolicitudesRevisadasTabla.vue?vue&type=script&lang=js"
export * from "./SolicitudesRevisadasTabla.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesRevisadasTabla.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports